import React from "react";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";

export default function ExportButton(props) {
  
  return (
    
    <CSVLink
      data={props.data}
      filename={`${props.pageModifier ? props.pageModifier + "_" : ""}${props.page}_${Date.now()}.csv`}
      headers={props.headers}
    >
      Export
    </CSVLink>
  );
}

ExportButton.propTypes = {
  data: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  page: PropTypes.string.isRequired,
  pageModifier: PropTypes.string,
};
